module.exports = __webpack_public_path__ + "media/images/recipes/beefburger-597b1e1384e6d676225ebaf82839bad5.pdf";